import { BATTLESHIP, EERIE, GYPSUM, OLAF } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEXT_AREA_HEIGHT = 160;

/* stolen from popover.private-tooltip--longform */
export const tooltipBorder = `
  border-radius: 3px;
  box-shadow: 0 1px 24px 0 rgb(0 0 0 / 8%);
  background-color: ${OLAF};
  border: 1px solid ${BATTLESHIP};
`;
export const LargeWrapper = styled.div.withConfig({
  displayName: "SharedStyleComponents__LargeWrapper",
  componentId: "sc-111xiv1-0"
})(["width:500px;height:250px;max-height:250px;display:flex;flex-direction:column;align-items:center;", ""], tooltipBorder);
export const GreyContainer = styled.div.withConfig({
  displayName: "SharedStyleComponents__GreyContainer",
  componentId: "sc-111xiv1-1"
})(["width:100%;display:flex;justify-content:", ";align-items:center;padding:12px;background:", ";"], ({
  hideNavigation
}) => hideNavigation ? 'flex-end' : 'space-between', GYPSUM);
export const Label = styled.div.withConfig({
  displayName: "SharedStyleComponents__Label",
  componentId: "sc-111xiv1-2"
})(["font-size:16px;font-weight:500;"]);
export const PopoverHeader = ({
  label,
  body,
  onCancel
}) => {
  return /*#__PURE__*/_jsxs(GreyContainer, {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      className: "p-left-1",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-1",
          name: "artificialIntelligence",
          size: 16
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Label, {
          children: label
        }), body && /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: body
        })]
      })]
    }), /*#__PURE__*/_jsx(UICloseButton, {
      "data-test-id": "close",
      className: "m-right-1",
      color: EERIE,
      onClick: onCancel,
      style: {
        position: 'static',
        fontSize: 16
      }
    })]
  });
};